import { useContext } from 'react';
import { TabContext } from './context';
export function useTabManager() {
    const context = useContext(TabContext);
    if (context === undefined) {
        throw new Error('Tab / TabNav / TabContent components must be used within a "Tabs" component');
    }
    return context;
}
